import "core-js/modules/es.string.link.js";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import useBreakpoints from 'hooks/useBreakpoints';
import useVisibleScreenContext from 'hooks/useVisibleScreenContext';
import { useViewerScoreBand } from 'utils/helix';
import Heading from 'components/Heading';
import Card from 'components/Card';
import UserGeneratedText from 'components/UserGeneratedText';
import FormattedText from 'components/FormattedText';
import Flag from 'components/Flag';
import Flex from 'components/Flex';
import IconDisc from 'components/IconDisc';
import Box from 'components/Box';
import Button from 'components/Button';
import { ScoreBandPill } from 'components/Pill';
import HelixScoreDisc from './HelixScoreDisc';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function SummaryFlagCard(_ref) {
  var titleId = _ref.titleId,
    summary = _ref.summary,
    summaryHtml = _ref.summaryHtml,
    subtitle = _ref.subtitle,
    score = _ref.score,
    _ref$decimalPlaces = _ref.decimalPlaces,
    decimalPlaces = _ref$decimalPlaces === void 0 ? 0 : _ref$decimalPlaces,
    link = _ref.link,
    children = _ref.children,
    screenContext = _ref.screenContext;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useBreakpoints = useBreakpoints(),
    isDesktop = _useBreakpoints.xs;
  var watchedElementRef = useVisibleScreenContext(screenContext !== null && screenContext !== void 0 ? screenContext : null);
  var band = useViewerScoreBand(score);
  return /*#__PURE__*/_jsxs(Flag, {
    token: /*#__PURE__*/_jsx(HelixScoreDisc, {
      score: score,
      decimalPlaces: decimalPlaces,
      fallback: isDesktop && /*#__PURE__*/_jsx(IconDisc, {
        size: "big",
        shady: true,
        name: "asset-activity"
      })
    }),
    align: "top",
    children: [/*#__PURE__*/_jsxs(Card, {
      ref: watchedElementRef,
      px: "m",
      py: "s",
      children: [/*#__PURE__*/_jsxs(Flex, {
        justifyContent: "space-between",
        alignItems: "center",
        gap: "xs",
        wrap: true,
        mb: subtitle ? 'xxs' : 's',
        children: [/*#__PURE__*/_jsx(Heading, {
          as: "h3",
          id: titleId,
          children: t('property_summary')
        }), band && /*#__PURE__*/_jsx(ScoreBandPill, {
          label: band.label,
          colour: band.colour
        })]
      }), subtitle && /*#__PURE__*/_jsx(Box, {
        dimmed: true,
        fontSize: "s",
        mb: "s",
        children: subtitle
      }), summaryHtml ? /*#__PURE__*/_jsx(FormattedText, {
        dangerouslySetInnerHTML: {
          __html: summaryHtml
        }
      }) : /*#__PURE__*/_jsx(UserGeneratedText, {
        text: summary
      }), children]
    }), link && /*#__PURE__*/_jsx(Button, {
      as: Link,
      mt: "s",
      variant: "primary",
      size: "medium",
      iconRight: "arrow-right",
      to: link,
      children: t('actions_view_full_analysis')
    })]
  });
}
export default SummaryFlagCard;